import {PdfViewer} from '@sdox/ui'

import type {XcNwBlock_BlockPdfPreviewType_Fragment} from '@sdox/api'

export type BlockPdfPreviewProps = XcNwBlock_BlockPdfPreviewType_Fragment

export const BlockPdfPreview = (props: BlockPdfPreviewProps) => {
  const {
    title,
    pdfPreviewUrl,
  } = props

  return (
    <PdfViewer
      className={'pb-8'}
      src={pdfPreviewUrl}
      title={title}
    />
  )
}
